import type { Viewer } from "@kaigi100-next/typing";
import firebase from "firebase/app";
import "firebase/firestore";
export const viewerConverter: firebase.firestore.FirestoreDataConverter<Viewer> = {
  toFirestore(viewer: Viewer): firebase.firestore.DocumentData {
    return viewer;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions
  ): Viewer {
    const data = snapshot.data(options);
    return {
      name: data.name,
      participatingConference: {
        id: data.participatingConference.id,
        name: data.participatingConference.name,
        viewerNameFieldOption:
          data.participatingConference.viewerNameFieldOption,
      },
      votingRestrictionSessions: data.votingRestrictionSessions ?? [],
      fulfilledConferenceId: data.fulfilledConferenceId ?? [],
      fulfilledAfterSessionSurveyConferenceId:
        data.fulfilledAfterSessionSurveyConferenceId ?? [],
      answeredPolls: data.answeredPolls ?? [],
      timeUpPolls: data.timeUpPolls ?? [],
      available: data.available ?? true,
      oc: data.oc ?? false,
      tagByConferences: data.tagByConferences ?? {},
      streamSessionId: data.streamSessionId ?? "",
      streamSetting: data.streamSetting ?? {
        videoEnable: false,
        audioEnable: false,
        videoDevice: "",
        audioDevice: "",
      },
      clubResponseSnapshot: data.clubResponseSnapshot ?? {
        firstName: "",
        lastName: "",
        occupation: "",
        id: "",
      },
      dismissAfterSessionSurvey: data.dismissAfterSessionSurvey ?? false,
      streamDisplay: data.streamDisplay ?? "show",
    };
  },
};
